<template>
<div>
    <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center" >
      <h1 class="title--1 mr-lg-3 mb-lg-0">Dashboard</h1>
      <p class="overview__text">
        This provides an overview of the data from the primary modules within the application.
      </p>
    </div>
    <article class="dashboard__schedule">
        <div class="row">
            <div class="col-md-6 p-2" v-if="hasPermissions(['QC-Inspection Read'])">
                <div class="dashboard-section dashboard-section--1 p-3">
                    <h1 class="title--1 mr-lg-3 mb-lg-0">Inspections Completed</h1>
                    <p class="mb-0 mt-2">The room type drop-down filters by room types linked to the displayed rooms or, when viewing inspections, by those tied to the inspections' templates.</p>
                    <FormDynamic :form_format="inspection_form_format" :form_data="inspection_form_data" :array_options="inspection_array_options" :content_align_x="'pt-0'" alt="inspection" @getSelectDateRange="getSelectDateRange($event, 'inspections')">
                        <template v-slot:start-fields>
                            <div class="formdynamic__item col-md-3 py-0 pl-0">
                                <div class="formdynamic__item__field">
                                    <label v-html="`View by:`" class="modal-label"/>
                                    <div class="btn-toolbar mt-1" role="toolbar" aria-label="Toolbar with button groups">
                                        <div class="btn-group mr-2" role="group" aria-label="First group">
                                            <button type="button" class="btn btn-option" :class="inspection_form_data.view_by == 1 ? 'active-option' :''" @click="inspection_form_data.view_by = 1">Rooms</button>
                                            <button type="button" class="btn btn-option" :class="inspection_form_data.view_by == 2 ? 'active-option' :''" @click="inspection_form_data.view_by = 2">Inspections</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:more-fields>
                                <button class="modal__buttons__item w-auto px-3 mt-3" v-html="'Apply search'" @click="getInspectionsData()" :disabled="loading_inspections"/>
                        </template>
                    </FormDynamic>
                    <GChart 
                        v-if="!loading_inspections"
                        type="ColumnChart"
                        :data="inspection_data"
                        :options="inspection_chart_options"
                        :resizeDebounce="500"
                    />
                    <div v-else-if="loading_inspections" class="text-center w-100" style="height: 3rem !important;">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2" v-if="hasPermissions(['Daily-Assignment Read'])">
                <div class="dashboard-section dashboard-section--1 p-3">
                    <div class="row justify-content-center mt-0">
                        <div class="btn-toolbar align-items-center" role="toolbar" aria-label="Toolbar with button groups">
                            <label v-html="`Retrieve data from:`" class="modal-label"/>
                            <div class="btn-group ml-2" role="group" aria-label="First group">
                                <button type="button" class="btn btn-option" :class="discharge_form_data.from_mobile_app == 1 ? 'active-option' :''" @click="discharge_form_data.from_mobile_app = 1">Mobile App</button>
                                <button type="button" class="btn btn-option" :class="discharge_form_data.from_mobile_app == 2 ? 'active-option' :''" @click="discharge_form_data.from_mobile_app = 2">Web App</button>
                                <button type="button" class="btn btn-option" :class="discharge_form_data.from_mobile_app == 3 ? 'active-option' :''" @click="discharge_form_data.from_mobile_app = 3">All</button>
                            </div>
                        </div>
                    </div>
                    <h1 class="title--1 mr-lg-3 mb-lg-0">Discharges</h1>
                    <FormDynamic :form_format="discharge_form_format" :form_data="discharge_form_data" :array_options="discharge_array_options" :content_align_x="'y'" alt="discharges">
                        <template v-slot:start-fields>
                            <div class="formdynamic__item col-md-3 py-0 pl-0">
                                <div class="formdynamic__item__field">
                                    <label v-html="`View by:`" class="modal-label"/>
                                    <div class="btn-toolbar mt-1" role="toolbar" aria-label="Toolbar with button groups">
                                        <div class="btn-group mr-2" role="group" aria-label="First group">
                                            <button type="button" class="btn btn-option" :class="discharge_form_data.view_by == 1 ? 'active-option' :''" @click="discharge_form_data.view_by = 1">Shift</button>
                                            <button type="button" class="btn btn-option" :class="discharge_form_data.view_by == 2 ? 'active-option' :''" @click="discharge_form_data.view_by = 2">Assignment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:more-fields>
                            <div class="formdynamic__item col-md-12 p-0" style="align-self: end">
                                <button class="modal__buttons__item w-auto ml-0 mr-2 px-3" v-html="'Apply search'" @click="getDischargesData()" :disabled="loading_discharges"/>
                                <a class="schedule-box__a-collapse" href="JavaScript:void(0);" @click="showDischargesAppliedModal()">
                                    See the discharges that were applied
                                </a>
                            </div>
                        </template>
                    </FormDynamic>
                    <div class="row" v-if="!loading_discharges">
                        <div class="col-md-6">
                            <input 
                                type="date"
                                v-model="discharge_form_data.date_1"
                                class="w-50"
                                @change="getDischargesData()"
                            />
                            <GChart
                                class="mt-2" 
                                type="PieChart"
                                :data="discharges_data_yesterday"
                                :options="discharges_chart_options"
                                :width="'100%'"
                                :height="'100%'"
                            />
                        </div>
                        <div class="col-md-6">
                            <input 
                                type="date"
                                v-model="discharge_form_data.date_2"
                                class="w-50"
                                @change="getDischargesData()"
                            />
                            <GChart
                                class="mt-2" 
                                type="PieChart"
                                :data="discharges_data_today"
                                :options="discharges_chart_options_2"
                            />
                        </div>
                    </div>
                    <div v-else-if="loading_discharges" class="text-center w-100" style="height: 3rem !important;">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2" v-if="hasPermissions(['Daily-Assignment Read'])">
                <div class="dashboard-section p-3">
                    <div class="row justify-content-center mt-0">
                        <div class="btn-toolbar align-items-center" role="toolbar" aria-label="Toolbar with button groups">
                            <label v-html="`Retrieve data from:`" class="modal-label"/>
                            <div class="btn-group ml-2" role="group" aria-label="First group">
                                <button type="button" class="btn btn-option" :class="rooms_cleaned_form_data.from_mobile_app == 1 ? 'active-option' :''" @click="rooms_cleaned_form_data.from_mobile_app = 1">Mobile App</button>
                                <button type="button" class="btn btn-option" :class="rooms_cleaned_form_data.from_mobile_app == 2 ? 'active-option' :''" @click="rooms_cleaned_form_data.from_mobile_app = 2">Web App</button>
                                <button type="button" class="btn btn-option" :class="rooms_cleaned_form_data.from_mobile_app == 3 ? 'active-option' :''" @click="rooms_cleaned_form_data.from_mobile_app = 3">All</button>
                            </div>
                        </div>
                    </div>
                    <h1 class="title--1 mr-lg-3 mb-lg-0">Rooms Cleaned</h1>
                    <FormDynamic :form_format="rooms_cleaned_form_format" :form_data="rooms_cleaned_form_data" :array_options="rooms_cleaned_array_options" :content_align_x="'y'" alt="rooms_cleaned" @getSelectDateRange="getSelectDateRange($event, 'rooms_cleaned')">
                        <template v-slot:more-fields>
                            <div class="col-md-12 px-0 pb-0">
                            <button class="modal__buttons__item w-auto px-3 mt-2 mr-2" v-html="'Apply search'" @click="getRoomsCleanedData()" :disabled="loading_rooms_cleaned"/>
                            <!-- <div class="col-md-12"> -->
                                <a class="schedule-box__a-collapse" href="JavaScript:void(0);" @click="showUncleanedRoomsModal()">
                                    See uncleaned rooms
                                </a>
                                <b class="mr-2 ml-2"> - </b>
                                <a class="schedule-box__a-collapse" href="JavaScript:void(0);" @click="showRoomsCleanedByRoomTypeModal()">
                                    See rooms cleaned by room type
                                </a>
                            </div>
                            <!-- </div> -->
                        </template>
                    </FormDynamic>
                    <div class="row" v-if="!loading_rooms_cleaned">
                        <div class="col-md-12 pt-0">
                            <GChart
                                class="mt-2" 
                                type="ColumnChart"
                                :data="rooms_cleaned_data"
                                :options="rooms_cleaned_chart_options"
                                :width="'100%'"
                                :height="'100%'"
                            />
                        </div>
                    </div>
                    <div v-else-if="loading_rooms_cleaned" class="text-center w-100" style="height: 3rem !important;">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-2" v-if="hasPermissions(['Census-Log-Productivity Read'])">
                <div class="dashboard-section p-3">
                    <div class="row justify-content-center mt-0">
                        <div class="btn-toolbar align-items-center" role="toolbar" aria-label="Toolbar with button groups">
                            <label v-html="`Retrieve data from:`" class="modal-label"/>
                            <div class="btn-group ml-2" role="group" aria-label="First group">
                                <button type="button" class="btn btn-option" :class="log_productivity_form_data.from_mobile_app == 1 ? 'active-option' :''" @click="log_productivity_form_data.from_mobile_app = 1">Mobile App</button>
                                <button type="button" class="btn btn-option" :class="log_productivity_form_data.from_mobile_app == 2 ? 'active-option' :''" @click="log_productivity_form_data.from_mobile_app = 2">Web App</button>
                                <button type="button" class="btn btn-option" :class="log_productivity_form_data.from_mobile_app == 3 ? 'active-option' :''" @click="log_productivity_form_data.from_mobile_app = 3">All</button>
                            </div>
                        </div>
                    </div>
                    <h1 class="title--1 mr-lg-3 mb-lg-0">Log Productivity</h1>
                    <FormDynamic :form_format="log_productivity_form_format" :form_data="log_productivity_form_data" :array_options="log_productivity_array_options" :content_align_x="'y'" alt="log_productivity" @getSelectDateRange="getSelectDateRange($event, 'log_productivity')">
                        <template v-slot:start-fields>
                            <div class="formdynamic__item col-md-4 py-0 pl-0">
                                <div class="formdynamic__item__field">
                                    <label v-html="`View by:`" class="modal-label"/>
                                    <div class="btn-toolbar mt-1" role="toolbar" aria-label="Toolbar with button groups">
                                        <div class="btn-group mr-2" role="group" aria-label="First group">
                                            <button type="button" class="btn btn-option" :class="log_productivity_form_data.view_by == 1 ? 'active-option' :''" @click="log_productivity_form_data.view_by = 1">Discharge Cap.</button>
                                            <button type="button" class="btn btn-option" :class="log_productivity_form_data.view_by == 2 ? 'active-option' :''" @click="log_productivity_form_data.view_by = 2">Prod %</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:more-fields>
                            <div class="col-md-6 px-0 pb-0">
                                <button class="modal__buttons__item w-auto px-3 mt-2 ml-0 align-self-center" style="height: 10px;" v-html="'Apply search'" @click="getLogProductivityData()" :disabled="loading_log_productivity"/>
                            </div>
                        </template>
                    </FormDynamic>
                    <div class="row" v-if="!loading_log_productivity">
                        <div class="col-md-12">
                            <GChart
                                class="mt-2" 
                                type="ColumnChart"
                                :data="log_productivity_data"
                                :options="inspection_chart_options"
                                :width="'100%'"
                                :height="'100%'"
                            />
                        </div>
                    </div>
                    <div v-else-if="loading_log_productivity" class="text-center w-100" style="height: 3rem !important;">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article> 
    <UncleanedRoomsModal ref="uncleaned_rooms" :rest_api="rest_api" :breadcrumb="breadcrumb" :array_options="rooms_cleaned_array_options"/>
    <RoomsCleanedByRoomTypeModal ref="rooms_cleaned_by_room_type" :rest_api="rest_api" :breadcrumb="breadcrumb"/>
    <DischargesAppliedModal ref="discharges_applied" :rest_api="rest_api" :breadcrumb="breadcrumb" :array_options="discharge_array_options"/>
</div>
</template>
<script>
import { GChart } from 'vue-google-charts/legacy'
import FormDynamic      from    '@/components/FormDynamic.vue'
import DashboardFormResources from './dashboard_form_resources';
import moment from 'moment'
import UncleanedRoomsModal from './UncleanedRoomsModal.vue';
import RoomsCleanedByRoomTypeModal from './RoomsCleanedByRoomTypeModal.vue';
import DischargesAppliedModal from './DischargesAppliedModal.vue';
import eventBus from '../../plugins/eventBus';
import { getSocket } from '../../plugins/socket';
import { debounce } from 'lodash';

export default {
    name: 'DashboardComponent',
    props: ['breadcrumb'],
    data() {
        return {
            rest_api: 'dashboard',

            inspection_data: [],
            inspection_form_format: DashboardFormResources.form_format,
            inspection_form_data: DashboardFormResources.form_data,
            inspection_array_options: {
                associate_id: [],
                room_type_id: [],
            },
            inspection_chart_options: {
                legend: {'position': 'bottom'},
                chartArea: {'width': '95%', 'height': '75%'},
                height: 380,
            },
            discharges_data_today: [],
            discharges_data_yesterday: [],
            loading_inspections: true,

            discharge_form_format: DashboardFormResources.form_format_discharges,
            discharge_form_data: DashboardFormResources.form_data_discharges,
            discharge_array_options: {
                daily_assignment_id: [],
                associate_id: []
            },
            discharges_chart_options: {
                chartArea: {'width': '95%', 'height': '90%'},
                height: 320,
                title: 'Discharges Today',
            },
            discharges_chart_options_2: {
                chartArea: {'width': '95%', 'height': '90%'},
                height: 320,
                title: 'Discharges Today',
            },
            loading_discharges: true,

            rooms_cleaned_data: [],
            rooms_cleaned_form_format: DashboardFormResources.form_format_rooms_cleaned,
            rooms_cleaned_form_data: DashboardFormResources.form_data_rooms_cleaned,
            rooms_cleaned_array_options: {
                room_type_id: [],
                essential_cleaning: []
            },
            rooms_cleaned_chart_options: {
                legend: {'position': 'bottom'},
                chartArea: {'width': '95%', 'height': '75%'},
                height: 484,
            },
            loading_rooms_cleaned: true,

            log_productivity_data: [],
            log_productivity_form_format: DashboardFormResources.form_format_log_productivity,
            log_productivity_form_data: DashboardFormResources.form_data_log_productivity,
            log_productivity_array_options: {
                daily_assignment_id: [],
                shift_id: [],
                cost_center_department_id: []
            },
            loading_log_productivity: true,
            message: '',
            selected_message: 0,
            interval: null,
            first_time_discharges: false,
            first_time_log_productivity: false,
            user: this.get_user()
        }
    },
    components:
    {
        GChart,
        UncleanedRoomsModal,
        RoomsCleanedByRoomTypeModal,
        DischargesAppliedModal,
        FormDynamic
    },
    watch: {
        async 'discharge_form_data.view_by'(val)
        {

            if(this.first_time_discharges)
            {
                this.discharge_form_data.daily_assignment_id = []
                this.discharge_form_data.shift_id = []
            }

            if(val === 2)
            {
                this.discharge_form_data.list_shift_types = false
                setTimeout(() => {
                    this.discharge_form_format[0].name = 'Daily Assignment:'
                    this.discharge_form_format[0].model_name = 'daily_assignment_id'
                    this.discharge_form_format[0].placeholder = 'Select daily assignments(s)'
                    this.discharge_form_format[1].style = 'visibility: hidden;'
                }, 100);
            }
            else
            {
                this.changeDischargeShiftFilter(this.discharge_form_data.list_shift_types)
                this.discharge_form_format[1].style = 'visibility: visible;'
            }
        },

        async 'discharge_form_data.list_shift_types'(val)
        {
            this.changeDischargeShiftFilter(val)
        },

        async 'log_productivity_form_data.list_shift_types'(val)
        {
            this.changeLogProductivityShiftFilter(val)
        },

        // async 'inspection_form_data.view_by'(val)
        // {
        //     this.changeInspectionFilter(val)
        // }
    },
    methods: {
        changeDischargeShiftFilter(val)
        {
            if(this.first_time_discharges)
            {
                this.discharge_form_data.shift_class_id = [] 
                this.discharge_form_data.shift_id = [] 
            }

            if(val)
            {
                this.discharge_form_format[0].name = 'Shift Type:'
                this.discharge_form_format[0].model_name = 'shift_class_id'
                this.discharge_form_format[0].placeholder = 'Select shift type(s)'
            }
            else
            {
                this.discharge_form_format[0].name = 'Shift:'
                this.discharge_form_format[0].model_name = 'shift_id'
                this.discharge_form_format[0].placeholder = 'Select shift(s)'
            }
        },

        changeInspectionFilter(val)
        {
            if(val === 1)
            {
                this.inspection_form_format[0].disabled = true;
                this.inspection_form_data.associate_id = []
                
            }
            else
            {
                this.inspection_form_format[0].disabled = false;
            }
        },

        changeLogProductivityShiftFilter(val)
        {
            if(this.first_time_log_productivity)
            {
                this.log_productivity_form_data.shift_class_id = [] 
                this.log_productivity_form_data.shift_id = [] 
            }

            if(val)
            {
                this.log_productivity_form_format[3].name = 'Shift Type:'
                this.log_productivity_form_format[3].model_name = 'shift_class_id'
                this.log_productivity_form_format[3].placeholder = 'Select shift type(s)'
            }
            else
            {
                this.log_productivity_form_format[3].name = 'Shift:'
                this.log_productivity_form_format[3].model_name = 'shift_id'
                this.log_productivity_form_format[3].placeholder = 'Select shift(s)'
            }
        },

        fill_data(data)
        {
            this.inspection_array_options =
            {
                associate_id: data.supervisors,
                room_type_id: data.room_types,
            }

            this.discharge_array_options = 
            {
                daily_assignment_id: data.daily_assignments,
                associate_id: data.associates,
                shift_id: data.shifts,
                shift_class_id: data.shift_classes
            }

            this.rooms_cleaned_array_options = {
                room_type_id: data.room_types,
                essential_cleaning: data.yes_no_options
            }

            this.log_productivity_array_options = {
                daily_assignment_id: data.daily_assignments,
                shift_id: data.shifts,
                shift_class_id: data.shift_classes,
                cost_center_department_id: data.cost_center_departments,
            }
        },

        async getInspectionsData(loader = true)
        {
            this.loading_inspections = loader
            const response = await this.post(`${this.rest_api}/inspections`, this.inspection_form_data)
            this.loading_inspections = false

            if(response.status)
            {
                localStorage.setItem(`dashboard_inspections_filters-${this.get_user().id}`, JSON.stringify(this.inspection_form_data))
                this.inspection_data = response.data.data
                if(!this.inspection_data.length)
                {
                    this.inspection_data.push(['No data', NaN])
                }
                console.log(this.inspection_data);
                if(this.inspection_form_data.view_by === 2)
                {
                    this.inspection_data.unshift(['Date', '# of completed inspections'])
                }
                else
                {
                    this.inspection_data.unshift(['Date', '# of rooms associated with inspections'])
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        async getDischargesData(loader = true)
        {
            this.loading_discharges = loader
            const response = await this.post(`${this.rest_api}/discharges`, this.discharge_form_data)
            this.loading_discharges = false

            if(response.status)
            {
                localStorage.setItem(`dashboard_discharges_filters-${this.get_user().id}`, JSON.stringify(this.discharge_form_data))
                this.discharges_data_today      = response.data.discharges_today
                this.discharges_data_yesterday  = response.data.discharges_yesterday

                const sum_yesterday = this.discharges_data_yesterday.reduce((accumulator, current) => {
                    return accumulator + current[1];
                }, 0);

                const sum_today = this.discharges_data_today.reduce((accumulator, current) => {
                    return accumulator + current[1];
                }, 0);

                this.discharges_chart_options.title = `Total: ${sum_yesterday}`
                this.discharges_chart_options_2.title = `Total: ${sum_today}`

                this.discharges_data_today.unshift(['Date', 'Discharges'])
                this.discharges_data_yesterday.unshift(['Date', 'Discharges'])
            }
            else
            {
                this.error_handling(response)
            }
        },

        async getRoomsCleanedData(loader = true)
        {
            this.loading_rooms_cleaned = loader
            const response = await this.post(`${this.rest_api}/rooms_cleaned`, this.rooms_cleaned_form_data)
            this.loading_rooms_cleaned = false

            if(response.status)
            {
                localStorage.setItem(`dashboard_rooms_cleaned_filters-${this.get_user().id}`, JSON.stringify(this.rooms_cleaned_form_data))
                this.rooms_cleaned_data = response.data.data
                this.rooms_cleaned_data.unshift(['Date', 'Rooms cleaned', 'Rooms left to clean'])
            }
            else
            {
                this.error_handling(response)
            }
        },

        async getLogProductivityData(loader = true)
        {
            this.loading_log_productivity = loader
            const response = await this.post(`${this.rest_api}/log_productivity`, this.log_productivity_form_data)
            this.loading_log_productivity = false

            if(response.status)
            {
                localStorage.setItem(`dashboard_log_productivity_filters-${this.get_user().id}`, JSON.stringify(this.log_productivity_form_data))
                this.log_productivity_data = response.data.data

                if(this.log_productivity_form_data.view_by === 2)
                {
                    this.log_productivity_data.unshift(['Date', 'Productivity %',])
                }
                else
                {
                    this.log_productivity_data.unshift(['Date', 'Discharge Capability',])
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        async showUncleanedRoomsModal()
        {
            window.$('#static-uncleaned-rooms').modal('show')
            this.$refs.uncleaned_rooms.getEssentialRoomsNotCleaned()
        },

        async showRoomsCleanedByRoomTypeModal()
        {
            window.$('#static-rooms-cleaned-by-room-type').modal('show')
            this.$refs.rooms_cleaned_by_room_type.getRoomsCleanedByRoomType()
        },

        async showDischargesAppliedModal()
        {
            window.$('#static-rooms-discharges-applied').modal('show')
            this.$refs.discharges_applied.getDischargesApplied()
        },

        hasSameKeys(obj1, obj2) {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            return keys1.length === keys2.length && keys1.every(key => keys2.includes(key));
        },

        getSelectDateRange(range, section)
        {
            range = range.toLowerCase().replace(/\s+/g, '')

            if(section === 'inspections')
            {
                this.inspection_form_data.date_option_selected = range
            }
            else if(section === 'rooms_cleaned')
            {
                this.rooms_cleaned_form_data.date_option_selected = range
            }
            else if(section === 'log_productivity')
            {
                this.log_productivity_form_data.date_option_selected = range
            }
        },

        fixSelectedDateOption(section, option)
        {
            let date_range = []
            switch (option) {
                case 'today':
                    date_range = this.getTodayRange()
                    break;
                case 'yesterday':
                    date_range = this.getYesterdayRange()
                    break;
                case 'thismonth':
                    date_range = this.getThisMonthRange()
                    break;
                case 'thisyear':
                    date_range = this.getThisYearRange()
                    break;
                case 'lastmonth':
                    date_range = this.getLastMonthRange()
                    break;
                case 'thisweek':
                    date_range = this.getThisWeekRange()
                    break;
                case 'lastweek':
                    date_range = this.getLastWeekRange()
                    break;
                default:
                    break;
            }

            if(!date_range.length)
            {
                return
            }

            date_range = {startDate: date_range[0], endDate: date_range[1]}

            console.log(section, option, date_range);

            if(section === 'inspections')
            {
                this.inspection_form_data.date_range = date_range
            }
            else if(section === 'rooms_cleaned')
            {
                this.rooms_cleaned_form_data.date_range = date_range
            }
            else if(section === 'log_productivity')
            {
                this.log_productivity_form_data.date_range = date_range
            }
        },

        getDebouncedLogProductivityData: debounce(function () {
            this.getLogProductivityData(false);
        }, 2000),


    },
    async mounted() {
        this.api_request()

        const startDate = moment().subtract(10, 'days').format('YYYY-MM-DD') + "T16:59:59.999Z";
        const endDate = moment().format('YYYY-MM-DD') + "T05:00:00.000Z";

        const startDateToday = moment(new Date()).format('YYYY-MM-DD')  + "T16:59:59.999Z";
        const endDateToday = moment(new Date()).format('YYYY-MM-DD') + "T05:00:00.000Z";

        this.log_productivity_form_data.date_range = { startDate: startDateToday, endDate: endDateToday }
        this.rooms_cleaned_form_data.date_range = { startDate, endDate }
        this.inspection_form_data.date_range = { startDate, endDate }

        let form_filters_inspections = localStorage.getItem(`dashboard_inspections_filters-${this.get_user().id}`)
        if(form_filters_inspections)
        {
            if(this.hasSameKeys(JSON.parse(form_filters_inspections), this.inspection_form_data))
            {
                this.inspection_form_data = form_filters_inspections ? JSON.parse(form_filters_inspections) : this.inspection_form_data
            }
        }
        this.fixSelectedDateOption('inspections', this.inspection_form_data.date_option_selected)

        let form_filters_discharges = localStorage.getItem(`dashboard_discharges_filters-${this.get_user().id}`)
        if(form_filters_discharges)
        {
            if(this.hasSameKeys(JSON.parse(form_filters_discharges), this.discharge_form_data))
            {
                this.discharge_form_data = form_filters_discharges ? JSON.parse(form_filters_discharges) : this.discharge_form_data
            }
        }

        let form_filters_rooms_cleaned = localStorage.getItem(`dashboard_rooms_cleaned_filters-${this.get_user().id}`)
        if(form_filters_rooms_cleaned)
        {
            if(this.hasSameKeys(JSON.parse(form_filters_rooms_cleaned), this.rooms_cleaned_form_data))
            {
                this.rooms_cleaned_form_data = form_filters_rooms_cleaned ? JSON.parse(form_filters_rooms_cleaned) : this.rooms_cleaned_form_data
            }
        }
        this.fixSelectedDateOption('rooms_cleaned', this.rooms_cleaned_form_data.date_option_selected)

        let form_filters_log_productivity = localStorage.getItem(`dashboard_log_productivity_filters-${this.get_user().id}`)
        if(form_filters_log_productivity)
        {
            if(this.hasSameKeys(JSON.parse(form_filters_log_productivity), this.log_productivity_form_data))
            {
                this.log_productivity_form_data = form_filters_log_productivity ? JSON.parse(form_filters_log_productivity) : this.log_productivity_form_data
            }
        }
        this.fixSelectedDateOption('log_productivity', this.log_productivity_form_data.date_option_selected)

        this.getInspectionsData()
        this.getRoomsCleanedData()

        this.discharge_form_data.date_1 = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.discharge_form_data.date_2 = moment().format('YYYY-MM-DD')
        await this.getDischargesData()
        this.first_time_discharges = true

        await this.getLogProductivityData()
        this.first_time_log_productivity = true
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },

    created()
    {
        eventBus.$on('dashboard', () => 
        {
            getSocket().on(`inspection-completed-for-dashboard-${this.get_user().facility_id}`, () => {
                this.getInspectionsData(false);
            })

            getSocket().on(`discharges-for-dashboard-${this.get_user().facility_id}`, () => {
                this.getDischargesData(false);
            })

            getSocket().on(`rooms-cleaned-for-dashboard-${this.get_user().facility_id}`, () => {
                this.getRoomsCleanedData(false);
            })

            getSocket().on(`log-productivities-for-dashboard-${this.get_user().facility_id}`, () => {
                this.getDebouncedLogProductivityData()
            })
        })
    }


}
</script>
<style lang="scss">
.vue-daterange-picker
{
    .form-control
    {
        height: 33px;
        font-size: 13.5px;
    }
}

.dashboard-section
{
    border: 1px solid #5655555c;
    height: 730px;

    &--1
    {
        height: 600px;
    }
}


.dashboard-section
{
    .formdynamic__item[class*="col-md-4"]:nth-child(2)
    {
        margin-right: 0px;
        margin-left: 0px;
    }
}

rect{
    background-color: black;
}

</style>

<style lang="scss" scoped>
.templates__grid__tabs_parent
{
    width: 18rem;  
}

.templates__grid__tabs__item
{
    height: 27px;
    padding-left: 0px;
}

.btn-option
{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 25px;
    font-size: 0.8rem;
    background-color: #fff;
    text-transform: none;
}

.active-option
{
    background-color: #0085DC;
    color: #ffff;
}
</style>
